import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SelectableClient } from 'src/app/core/models/selectable-client';
import {
  AuthenticationService,
  DefaultsService,
  EquipmentService,
  LocationService,
  ProfileService,
} from 'src/app/core/providers';
import { FiltersService } from '../../../filters/filters.service';

@Component({
  selector: 'app-client-selection',
  templateUrl: './client-selection.component.html',
  styleUrls: ['./client-selection.component.scss'],
  standalone: false,
})
export class ClientSelectionComponent implements OnInit, OnDestroy {
  clients: SelectableClient[] = [];
  currentClientId?: string | null;
  subscriptions: Subscription[] = [];
  constructor(
    public authenticationService: AuthenticationService,
    public router: Router,
    public profileService: ProfileService,
    public locationService: LocationService,
    public defaultsService: DefaultsService,
    public equipmentService: EquipmentService,
    public filtersService: FiltersService
  ) {}

  ngOnInit(): void {
    this.authenticationService.startSentryTransaction(
      this.router.routerState.snapshot.url
    );
    this.currentClientId = this.authenticationService.getClientId()?.toString();
    this.clients = this.authenticationService
      .getSelectableClients()
      .filter((r) => r.MQARestricted === false);
    this.subscriptions.push(
      this.profileService.clientsLoaded.subscribe((clients) => {
        this.clients = clients;
        this.authenticationService.finishSentryTransaction();
      })
    );
  }

  setSelectedClient = (clientId: number) => {
    this.currentClientId = clientId.toString();
    const selectedClient =
      this.authenticationService.userInfoView.SelectableClients.find(
        (r) => r.ClientID === clientId
      );
    if (selectedClient) {
      this.authenticationService.userInfoView.updateSelectedClient(
        selectedClient,
        this.defaultsService
      );
    }
    this.filtersService.clearCache();
    this.equipmentService.clearCache();
    this.profileService.clearCache(
      this.authenticationService.userInfoView.SelectedClient.ClientID
    );
    this.locationService.clearCache();
    this.router.navigate(['/settings']);
  };

  ngOnDestroy() {
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
  }
}
